import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useCompanyCode } from 'hooks';

export interface CompanySelectBox {
  codeValue?: number|undefined;
  boxSize?: string;
  onChangeSelect?: (value: string | number) => void;
}

const CompanyCode = ({
  codeValue,
  boxSize = '150px',
  onChangeSelect
}: CompanySelectBox): React.ReactElement => {
    
 /* ======================================================
   * variables
   * ====================================================== */
 const [ searchValue, setSearchValue ] = useState<string>();
 const [ company, setCompany ] = useState<number|undefined|null>(null);
  
 /* ======================================================
 * hooks
 * ====================================================== */

 const { codeList} = useCompanyCode({params: {searchValue, company: company?company:undefined}});  

 /* ======================================================
 * events
 * ====================================================== */  
 
 /* ======================================================
  * effects
  * ====================================================== */
 useEffect(() => {
   setCompany(codeValue);
}, [codeValue])


  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width: boxSize}}
      value={!!company?Number(company):null}
      placeholder="고객사 선택" 
      options={codeList} 
      virtual={false}
      showSearch={true} 
      onSearch={(value) => {
        setCompany(0);
        setSearchValue(value);
      }}
      optionFilterProp="label"       
      onSelect={onChangeSelect}                     
      allowClear={true}
      onClear={()=>{
        setCompany(null); 
        setSearchValue(''); 
        onChangeSelect && onChangeSelect('');
      }}
  />    
  );
};

export default CompanyCode;
